// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { SiAuth0 as RawSiAuth0 } from "react-icons/si";
export const SiAuth0 = /* @__PURE__ */ createIcon(RawSiAuth0, "SiAuth0", 0);
